export const DEFAULT_QUEUE_TIME = 3;
export const DEFAULT_RETRY_LIMIT = 1;
export const DEFAULT_LARGE_SEND_RECIPIENT_COUNT = Infinity;
